import CreateCommunity from './CreateCommunity';

export default CreateCommunity;